import {cartAdd, changeCart, getCurrentCart} from '@process-creative/slate-theme-tools';

export async function checkFreeGifts(id: number) {
  const giftsTriggerEls = document.querySelectorAll<HTMLElement>(
    '[data-free-gifts-trigger-products]'
  );

  for (const giftTrigger of giftsTriggerEls) {
    const giftsTrigger = giftTrigger
      ?.getAttribute('data-free-gifts-trigger-products')
      ?.split('|');
    const giftsListEl = document.querySelector<HTMLElement>('[data-free-gifts]');
    const giftsList = giftsListEl?.getAttribute('data-free-gifts')?.split('|');
    const giftsIds = giftsList
      ? giftsList.map((product) => parseInt(product, 10))
      : null;

    const cartFetch = getCurrentCart();
    const cart = cartFetch;
    const cartItems = cart.items;
    const mapCart = giftsIds?.map((item: any) =>
      cartItems.some((cartItem: any) => cartItem.id === item)
    );

    // eslint-disable-next-line id-length
    const ifInCart = mapCart?.reduce((a: any, b: any) => a && b);
    const variablesGifts =
      giftsTrigger && giftsTrigger?.map((item: any) => item);

    let isGiftInCart = false;
    cartItems.forEach((item) => {
      const variantId = item.variant_id;
      const variantProperties = item.properties;
      giftsIds.forEach((id: number) => {
        if (id === variantId && Object.keys(variantProperties).length !== 0) {
          isGiftInCart = true;
        }
      });
    });

    if (ifInCart && !isGiftInCart) {
      for (const item of cartItems) {
        const variantId = item.variant_id;
        const variantQty = item.quantity;
        const variantKey = item.key;

        if (giftsIds) {
          for (const id1 of giftsIds) {
            if (!isNaN(id1) && id1 === variantId && variantQty === 1 && variablesGifts?.includes(id.toString())) {
              const formData = new FormData();
              formData.append('id', String(id1));
              formData.append('quantity', '1');
              formData.append('properties[_free_gift]', 'true');
              formData.append('properties[_free_gift_parent_ids]', JSON.stringify(giftsTrigger));

              fetch('/cart/change.js', {
                method: 'POST',
                body: formData,
              })
                .then((response) => response.json())
                .then((data) => {
                  document.dispatchEvent(new Event('refreshCart'));
                } )
                .catch((err) => console.error('Error updating cart:', err));
            } else if (!isNaN(id1) && id1 === variantId && variantQty > 1 && variablesGifts?.includes(id.toString())) {
              try {
                await addFreeGift(giftsIds, giftsTrigger);
                isGiftInCart = true;
                let quantity = variantQty - 1;
                let key = variantKey;
                const currentVariant = {key, quantity};
                await changeCart(currentVariant);

                document.dispatchEvent(new Event('refreshCart'));
              } catch (err) {
                console.error('Error adding free gift:', err);
              }
            }
          }
        }
      }
    }

    return (
      variablesGifts?.includes(id.toString()) &&
      !ifInCart &&
      addFreeGift(giftsIds, giftsTrigger)
    );
  }

  return null;
}

async function addFreeGift(giftsIds: any, parentIds: any) {
  const items: any[] = [];
  if (giftsIds) {
    giftsIds?.forEach((id: number) => {
      if (!isNaN(id)) {
        items.push({
          id,
          quantity: 1,
          properties: {
            _free_gift: true,
            _free_gift_parent_ids: parentIds,
          },
        });
      }
    });
  }
  return items.length && cartAdd({ items });
}
